import React, { useState, useEffect } from 'react';
import { Paper, styled } from '@mui/material';
import RichTextEditor from '../../../../../common/RichTextEditor';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  margin: theme.spacing(2),
  minHeight: '842px', // A4 height
  width: '595px', // A4 width
  backgroundColor: '#fff',
  overflow: 'hidden',
  position: 'relative',
  boxSizing: 'border-box',
  fontSize: '12px',
  lineHeight: 1.4,
  '& [contenteditable="true"]': {
    outline: 'none !important',
    '&:focus': {
      outline: 'none !important',
      background: 'transparent !important',
    },
  },
  '& .ProseMirror': {
    maxWidth: '100%',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    padding: '10px 20px',
    '& p': {
      maxWidth: '100%',
    },
    '& h3': {
      fontSize: '13px !important',
      fontWeight: 'bold',
    },
  },
}));

interface ActionItemsEditorProps {
  actionItems: string;
  onChange: (actionItems: string) => void;
}

const ActionItemsEditor: React.FC<ActionItemsEditorProps> = ({ actionItems, onChange }) => {
  const [content, setContent] = useState('');

  useEffect(() => {
    let baseHtml = actionItems || '';

    // If no saved HTML, generate the base template
    if (!baseHtml) {
      baseHtml = `
        <div class="action-items" style="font-family: Times New Roman, serif; font-size: 12px;">
          <h3 class="action-items-heading" style="font-weight: bold; margin-bottom: 0.5rem; font-size: 15px !important;">1.2. Action Items</h3>
          <p>Following is a summary of questions, comments, needs, or suggestions we have concerning our observations made at the site and our review of the Application for Payment and associated documentation.</p>
          <ol>
            <li>[Add action items]</li>
          </ol>
        </div>
      `;
    }

    setContent(baseHtml);
  }, [actionItems]);

  const handleChange = (newContent: string) => {
    setContent(newContent);
    onChange(newContent);
  };

  return (
    <StyledPaper elevation={2}>
      <RichTextEditor value={content} onChange={handleChange} height={842} scale={1} />
    </StyledPaper>
  );
};

export default ActionItemsEditor;
